import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-207c8b61")
const _hoisted_1 = { class: "form-card" }
const _hoisted_2 = { class: "form-icons card-icons" }
const _hoisted_3 = ["title"]
const _hoisted_4 = {
  key: 0,
  class: "center title-3"
}
const _hoisted_5 = { class: "body" }
const _hoisted_6 = {
  key: 1,
  class: "buttons"
}
const _hoisted_7 = { key: 2 }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("dig-ui-loader", null, null, -1)
const _hoisted_9 = [
  _hoisted_8
]
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_bottom_button = _resolveComponent("base-bottom-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("dig-ui-icon", {
        type: "close",
        class: "icon-button",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.cancel())),
        title: _ctx.$t('cancel')
      }, null, 8, _hoisted_3)
    ]),
    (_ctx.title)
      ? (_openBlock(), _createElementBlock("dig-ui-title", _hoisted_4, _toDisplayString(_ctx.title), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ]),
    (!_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createVNode(_component_base_bottom_button, {
            class: "cancel",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.cancel())),
            disabled: _ctx.disabled
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('cancel')), 1)
            ]),
            _: 1
          }, 8, ["disabled"]),
          _createVNode(_component_base_bottom_button, {
            class: "validate",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.validate())),
            disabled: _ctx.disabled
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('validate')), 1)
            ]),
            _: 1
          }, 8, ["disabled"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9))
      : _createCommentVNode("", true)
  ]))
}